<template>
    <div class="house-map">
        <h1 class="title">地理位置</h1>
        <div class="address">
            <img src="@/assets/img/shareHouse/marker_blue.svg" alt="">
            {{address}} 
        </div>
        <div id="share-map-content"></div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    data () {
        return {
            map: null,
            // center: {lat:25.0882456, lng:121.4905524},
            zoom: 16,
            marker: require('@/assets/img/shareHouse/marker_red.png')
        }
    },
    mounted () {
        // this.initMap() 
        // this.setMarkers()
        // this.setCircle()
        
    },
    watch: {
        center: {
            handler: function (val) {
                // console.log(val)
                if(val){
                    this.initMap()  
                }
            },
            // immediate: true,
            deep: true
        }
    },
    methods: {
        initMap: function () {
            let _self = this
            _self.map = new google.maps.Map(document.getElementById("share-map-content"), {
                center: _self.center,
                zoom: _self.zoom,
                maxZoom: 20,
                minZoom: 3,
                streetViewControl: false,
                mapTypeControl: false
            })
            if(_self.isHidden){
                _self.setCircle()
            }else{
                _self.setMarkers()
            }
            _self.map.addListener('tilesloaded', function () { 
                _self.$store.dispatch('setShareHouseMapLoaded', true)
                console.log('loaded')
            })
        },
        setMarkers: function () {
            const marker = new RichMarker({
                // 設定為該餐廳的座標
                position: new google.maps.LatLng(this.center.lat, this.center.lng),
                map: this.map,
                shadow: 0,
                content: '<div class="vending-machine"><img width="20px" src="'+this.marker+'" /><span></span></div>',
            });
        },
        setCircle: function () {
            const cityCircle = new google.maps.Circle({
                strokeColor: "",
                strokeOpacity: 0.0,
                strokeWeight: 2,
                fillColor: "#3fccfc",
                fillOpacity: 0.5,
                map: this.map,
                center: this.center,
                radius: 200,
            });
        }
    },
    computed: {
        ...mapGetters({
            address: 'GET_SHARE_HOUSE_ADDRESS',
            center: 'GET_SHARE_HOUSE_LAT_LNG',
            isHidden: 'GET_SHARE_HOUSE_NUM_HIDDEN'
        })
    },
}
</script>
<style lang="scss" scoped>
    .house-map{
        position: relative;
        width: 100%;
        margin-bottom: -25px;
        h1.title{
            margin-bottom: 20px;
            font-size: 28px;
            color: #3a455f;
        }
        .address{
            display: flex;
            align-items: center;
            font-size: 16px;
            margin-bottom: 23px;
            img{
                margin-right: 6px;
            }
        }
        #share-map-content{
            width: 100%;
            height: 418px;
            margin-bottom: 24px;
        }
    }
    @media (max-width: 992px) {
        .house-map{
            h1.title{
                margin-bottom: 16px;
                font-size: 20px;
            }
            #share-map-content{
                height: calc(100vw * 450.0 / 992.0);
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/shareHouse/houseMap.vue